import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, useHTTPQuery } from "@/lib/http";

export interface GetPreferredPriceSourceResponseModel {
	readonly priceSource: PriceSource;
}

export const usePreferredPriceSource = () => {
	const http = useHTTP("Required");
	return useHTTPQuery({
		queryKey: ["preferredPriceSource"],
		queryFn: () => {
			return http<GetPreferredPriceSourceResponseModel>({
				method: "GET",
				url: "/settings/preferred-price-source"
			});
		}
	});
};
